import { IUserUpdateRequest } from "./user-update.interface";
import { UserReviewFormType, UserUpdateFormType } from "./user-update.schema";

export const mapToUserUpdateRequest = (user: UserUpdateFormType): IUserUpdateRequest => {
  return {
    firstName: user.firstName?.trim(),
    lastName: user.lastName?.trim(),
    phone: user.phone?.replaceAll("-", ""),
    location: user.location,
    placeId: user.placeId || null,
    address: user.address || null,
    addressInfo: {
      country: user.country || "",
      streetAddress: user.streetAddress || "",
      zipCode: user.zipCode || "",
      townCity: user.townCity || "",
    },
  };
};

export const mapToUserReviewRequest = (user: UserReviewFormType): IUserUpdateRequest => {
  return {
    firstName: user.firstName.trim(),
    lastName: user.lastName.trim(),
    phone: user.phone?.replaceAll("-", ""),
    location: user.location,
    placeId: user.placeId || null,
    address: user.address || null,
    addressInfo: {
      country: user.country || "",
      streetAddress: user.streetAddress || "",
      zipCode: user.zipCode || "",
      townCity: user.townCity || "",
    },
  };
};
